<script>
    import { Button, Typography } from '$lib/components/UI'
    import { createEventDispatcher } from 'svelte'
    export let config = {}
    const dispatch = createEventDispatcher()

    function onPreview() {
        dispatch('preview')
    }

    function onUpdate() {
        dispatch('update')
    }

    $: fields = config?.updateFields
        ? config.updateFields.length || config.fields.length
        : 0
    $: docs = config?.docs ? config.docs.length : 0
</script>

<div>
    <span style="flex-direction: column;">
        <Typography type="h4" color="grey-800" style="padding: 0; margin: 0"
            >Solicitud de Modificación en curso</Typography
        >
        <span style="justify-content: flex-start;">
            {#if fields}
                <Typography
                    color="grey-800"
                    type="subtitle"
                    style="padding: 0; margin: 0"
                    ><i>{fields}</i> Campos</Typography
                >
            {/if}
            {#if docs}
                <Typography
                    color="grey-800"
                    type="subtitle"
                    style="padding: 0; margin: 0"
                    ><i>{docs}</i> Documentos</Typography
                >
            {/if}
        </span>
    </span>
    <span>
        {#if config?.editable}
            <Button on:click={onUpdate} size="small" label="Modificar" />
        {:else}
            <Button
                on:click={onPreview}
                type="other"
                size="small"
                label="Ver"
            />
        {/if}
    </span>
</div>

<style>
    div {
        display: flex;
        border-radius: 8px;
        background: #fff;
        padding: 13px 28px;
        box-shadow: 0px 2px 20px 0px rgba(0, 0, 0, 0.1);
        flex-direction: row;
        justify-content: space-between;
        align-items: center;
    }
    span {
        display: flex;
        position: relative;
        flex-direction: row;
        padding: 0;
        margin: 0;
        gap: 14px;
        justify-content: space-between;
    }
    i {
        font-style: normal;
        font-weight: 700;
        color: #00669E;
    }
</style>
